import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Routes from './routes';
import ErrorBoundary from './components/ErrorBoundary';
import Promise from 'bluebird';
import Hotjar from '@hotjar/browser';
import i18next from 'src/core/i18next';
import store from './store/store';

Promise.config({
	cancellation: true,
	longStackTraces: false,
	warnings: false
});

const siteId = window.location.origin === 'https://dev-activate.iq-series.com' || window.location.origin === 'https://staging-activate.iq-series.com' ? 4948609 : 3741179;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);
i18next;

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<ErrorBoundary>
			<Routes />
		</ErrorBoundary>
	</Provider>
);
